import {loginContainer} from '@wallaby-ui/core';
import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {connect} from 'react-redux';

import DynamicAutoLayoutBox from './DynamicAutoLayoutBox';
import {
  changeSelectedScreenId,
  loadMiniScreensConfig,
} from '../auto_layout_actions';
import {getSelectedScreenId} from '../auto_layout_selectors';

class DynamicAutoLayoutContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelectedScreenIdChange =
      this.handleSelectedScreenIdChange.bind(this);
    const {
      autoLayoutStateId,
      config,
      configStateId,
      miniScreensConfig,
      screenId,
    } = this.props;

    // load screen config if screenId is not provided
    if (
      isEmpty(screenId) &&
      (isEmpty(miniScreensConfig) || !miniScreensConfig.isLoaded())
    ) {
      this.props.loadMiniScreensConfig(
        autoLayoutStateId,
        config.service.url.miniScreensConfig,
        configStateId
      );
    }
  }

  handleSelectedScreenIdChange(screenId) {
    const {autoLayoutStateId, contextParams} = this.props;
    this.props.changeSelectedScreenId(
      autoLayoutStateId,
      screenId,
      contextParams
    );
  }

  render() {
    const {
      autoLayoutStateId,
      config,
      configStateId,
      contextParams,
      helpText,
      metadata,
      miniScreensConfig,
      selectedScreenId,
      screenId,
      screenStyles,
      showBoxHeader,
      titleText,
    } = this.props;
    const currentScreenId = screenId || selectedScreenId;
    return (
      <DynamicAutoLayoutBox
        autoLayoutStateId={autoLayoutStateId}
        config={config}
        configStateId={configStateId}
        contextParams={contextParams}
        handleSelectedScreenIdChange={this.handleSelectedScreenIdChange}
        metadata={metadata}
        miniScreensConfig={miniScreensConfig}
        screenId={currentScreenId}
        screenStyles={screenStyles}
        showBoxHeader={showBoxHeader}
        titleText={titleText}
        helpText={helpText}
      />
    );
  }
}

DynamicAutoLayoutContainer.displayName = 'DynamicAutoLayoutContainer';

DynamicAutoLayoutContainer.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  configStateId: PropTypes.string.isRequired,
  contextParams: PropTypes.objectOf(PropTypes.any).isRequired,
  screenId: PropTypes.string,
  screenStyles: PropTypes.objectOf(PropTypes.any),
  showBoxHeader: PropTypes.bool,
  titleText: PropTypes.string,
  helpText: PropTypes.string,
};

DynamicAutoLayoutContainer.defaultProps = {
  screenId: undefined,
  screenStyles: undefined,
  showBoxHeader: false,
  titleText: '',
  helpText: '',
};

export default connect(
  (state, props) => ({
    miniScreensConfig: state[props.autoLayoutStateId].miniScreensConfig,
    selectedScreenId: getSelectedScreenId(state, props),
  }),
  {
    changeSelectedScreenId,
    loadMiniScreensConfig,
  }
)(DynamicAutoLayoutContainer);
